import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBuildings: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"buildings, company, workspace"} maskId="square-filled-radius-0-stroke-1-IconBuildings"><path fillRule="evenodd" clipRule="evenodd" d="M3 3H15V19H16V7H21V19H23V20H1V19H3V3ZM7 8H11V9H7V8ZM7 12H11V13H7V12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBuildings;
